import InnerBanner from './InnerBanner';

function Banner(){
    return <>
        <div className="banner">
            <InnerBanner />
        </div>
    </>
}
export default Banner